/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from "@material-ui/icons/Search";
import { Button, Chip, InputAdornment } from "@material-ui/core";
import Link from '@material-ui/core/Link';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import DepartmentList from "./departmentList";
import SpecializationList from "./specializationList";
import UserList from "./userList";
import TableData from "./tableData";
import AppointmentTable from "./appointmentTable";
// import SortOutlinedIcon from "@material-ui/icons/SortOutlined";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import "../styles.css";
import "../../../../ui-styles/nodata/NoData.css"
import { getReports, getApptbyId } from "../../../../actions/appointment";
import Loader from "../../../../lib/ui/loader/Loader";

function SearchDoctors() {
    const [from, setFrom] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [to, setTo] = useState(new Date().setHours(23, 59, 59, 999));
    const [isDateChanged, setIsDateChanged] = useState(false);
    const [appFrom, setAppFrom] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [appTo, setAppTo] = useState(new Date().setHours(23, 59, 59, 999));
    const [reportData, setReportData] = useState([]);
    const [doctorList, setDoctorList] = useState([]);
    const [selectedChips, setSelectedChips] = useState([]);
    // const [specialistList, setSpecialistList] = useState({});
    const [uniqueSpecialData, setUniqueSpecialData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [dep, setDep] = useState();
    const [spec, setSpec] = useState();
    const [departmentList, setDepartmentList] = useState([]);
    const [allDepartment, setAllDepartment] = useState([]);
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [cancelSearch, setCancelSearch] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [appointmentData, setAppointmentData] = useState([]);
    const [appCount, setAppCount] = useState(0);
    const [user, setUser] = useState('Doctor')
    const [userName, setUserName] = useState()
    const prevFromRef = useRef(from);
    const prevToRef = useRef(to);

    useEffect(() => {
        handleCancel()
        setUserName()
        getDoctorsList()
    }, [user])

    useEffect(() => {
        if (!cancelSearch && dep === null && spec === null && selectedChips.length === 0) {
            getFinalReports();
            setDep()
        }
    }, [cancelSearch, dep, spec, selectedChips, from, to]);

    useEffect(() => {
        if (prevFromRef.current !== from || prevToRef.current !== to) {
            setIsDateChanged(true); 
            setAppFrom(from)
            setAppTo(to)
        } else {
            setIsDateChanged(false);
        }
        prevFromRef.current = from;
        prevToRef.current = to;
    }, [from, to]);
    
    useEffect(() => {
        if(selectedUserId){
            getAppointmentDetail(selectedUserId)
        }
    }, [appFrom, appTo])
    
    useEffect(() => {
        getFinalReports();
    }, [page, rowsPerPage])

    useEffect(() => {
        if (dep && dep !== undefined && user === 'Doctor') {
            specialistFun();
        }
    }, [dep, user]);

    const specialistFun = () => {
        const uniqueArray = doctorList?.length > 0 && doctorList.filter((doctor, index) => {
            return (
                doctor.departmentId === dep.departmentId &&
                !doctorList.slice(0, index).some((obj) => obj.specialityId === doctor.specialityId)
            );
        });

        if (!uniqueArray.includes(spec)){
            setSpec()
        }

        setUniqueSpecialData(uniqueArray);
    };

    const getDoctorsList = () => {
        getReports(`userList&role=${user.toLowerCase()}`)
        .then((res) => {
                if (res?.status) {
                    if (res?.data?.length > 0) {
                        if(user === 'Doctor'){
                            setDepartmentList(res?.data);
                            setAllDepartment(res?.data)
                        }
                        // setCount(res?.length);
                        setDoctorList(res?.data); 
                    }
                }
            })
            .catch((error) => {
                console.log("error in getDoctorList=======>?", error);
            });

    };

    const getFinalReports = (e) => {
        if (e === "clicked") {
            setCancelSearch(true);
        }
        setLoader(true)
        let query = `final&from=${from.valueOf()}&to=${to.valueOf()}&role=${user.toLowerCase()}`;
        if(user === 'Doctor'){
            dep && (query += `&department=${dep.departmentId}`)
            spec && (query += `&speciality=${spec.specialityId}`)
        }
        if (selectedChips && selectedChips?.length > 0 ) {
            query += `&userId=${selectedChips.map(a => a.userId).join(',')}`;
        }
        
        query += `&skip=${page ? page : 0}`;
        query += `&limit=${rowsPerPage ? rowsPerPage : 10}`;
        
        getReports(query)
        .then((res) => {
            if (res?.status) {
                if (res?.data.length >= 0) {
                    setLoader(false);
                    setReportData(res?.data);
                    setCount(res?.length);
                }
            }
        })
        .catch((error) => {
            console.log("error.......:)", error);
            setLoader(false);
        });
    };
    
    const getAppointmentDetail = (userId, appPage = 0, appRowsPerPage = 10) => {
        setLoader(true) 
        const skip= appPage
        const limit= appRowsPerPage
        getApptbyId(appFrom.valueOf(), appTo.valueOf(), userId, user.toLowerCase(), skip, limit)
        .then((res) => {
            if (res?.status) {
                if (res?.data.length >= 0) {
                    setLoader(false);
                    if(user === 'Doctor'){
                        setUserName(res?.data[0]?.doctorData?.name);
                    } else {
                        setUserName(res?.data[0]?.patientData?.name)
                    }
                    setAppointmentData(res?.data);
                    setAppCount(res?.totalCount);
                }
            }
        })
        .catch((error) => {
            console.log("error.......:)", error);
            setLoader(false);
        });
    };
    
    const handleCancel = () => {
        setDep(null)
        setSpec(null);
        setUniqueSpecialData([]);
        // setFrom(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
        // setTo(new Date().setHours(23, 59, 59, 999));
        setSelectedChips([]);
        setIsDateChanged(false);    
        setCancelSearch(false);
    };
    
    const handleBack = () => {
        setSelectedUserId(null)
        setUserName()
        setAppFrom(from)
        setAppTo(to)
    };
    
    
    const handleAutocompleteChange = (event, values) => {
        setCancelSearch(false)
        if (values !== undefined) {
            if (typeof (values) !== 'string') {
                setSelectedChips([...selectedChips, values]);
            }
        }       
    };
    
    const handleDeleteChip = (chipToDelete) => {
        setSelectedChips((chips) => chips.filter((chip) => chip !== chipToDelete));
        setCancelSearch(false)
        // updateSpecialisationList(selectedChips)
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredDoctorList = doctorList.filter((doctor) => {
        return !selectedChips.some((chip) => chip.userId === doctor.userId);
    });

    return (
        <div className="flexCol pdngSM">
            { !selectedUserId ? 
            <>
                <div className="flexWrap alignCntr">
                    <div className="searchBarWidth pdngXS">
                        <Autocomplete
                            id="combo-box-demo"
                            freeSolo
                            fullWidth
                            options={filteredDoctorList}
                            disableClearable
                            size="small"
                            getOptionLabel={(option) => option.firstName}
                            onChange={handleAutocompleteChange}
                            value={selectedChips}
                            renderInput={(params) => (
                                <TextField
                                    fullWidth
                                    {...params}
                                    placeholder="Search..."
                                    InputProps={{
                                        ...params.InputProps,
                                        type: "search",
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />
                            )}
                        />
                        <div className="mobSearch">
                            <ul className="flexWrap alignCntr">
                                {selectedChips.map((each) => (
                                    <>
                                        <li className="pdngXS">
                                            <Chip
                                                key={each.userId}
                                                label={each.firstName}
                                                onDelete={() => handleDeleteChip(each)}
                                                value={each.firstName}
                                            />
                                        </li>
                                    </>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="datePickerWidth pdngXS">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                fullWidth
                                size="small"
                                className="pickerInput"
                                inputVariant="outlined"
                                value={from}
                                onChange={(d) => {
                                    setFrom(d);
                                }}
                                animateYearScrolling
                                placeholdertext="from"
                                format="dd/MM/yyyy"
                                maxDate={new Date()}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div className="datePickerWidth pdngXS">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                fullWidth
                                size="small"
                                className="pickerInput"
                                inputVariant="outlined"
                                value={to}
                                onChange={(d) => {setTo(d); 
                                }}
                                animateYearScrolling
                                placeholdertext="to"
                                format="dd/MM/yyyy"
                                maxDate={new Date()}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    {/* <div> */}
                        <div className=" pdngXS">
                            <UserList
                                user = {user}
                                setUser={setUser}
                            />
                        </div>
                    {/* </div> */}
                    {user === 'Doctor' && 
                        <>
                            {/* <div> */}
                                <div className=" pdngXS">
                                    <DepartmentList
                                        selectedChips={selectedChips}
                                        setUniqueSpecialData={setUniqueSpecialData}
                                        uniqueSpecialData={uniqueSpecialData}
                                        dep={dep}
                                        setDep={setDep}
                                        setSpec={setSpec}
                                        doctorList={doctorList}
                                        departmentList={departmentList}
                                        allDepartment={allDepartment}
                                        setDepartmentList={setDepartmentList}
                                        setCancelSearch={setCancelSearch}
                                    />
                                </div>
                            {/* </div> */}
                            {/* <div> */}
                                <div className=" pdngXS">
                                    <SpecializationList uniqueSpecialData={uniqueSpecialData} setSpec={setSpec} spec={spec} setCancelSearch={setCancelSearch} />
                                </div>
                            {/* </div> */}
                        </>
                    }
                    {!cancelSearch ? 
                    <div>
                    <div className="filterWidth pdngXS" >
                        <Button size="medium" style={{ minWidth: "150px" }} color="primary" variant="outlined" disableElevation disableRipple disabled={!(selectedChips.length > 0 || dep || isDateChanged)} onClick={() => getFinalReports("clicked")}>
                            search
                        </Button>
                    </div>
                    </div>
                     : <div className="filterWidth pdngXS" >
                        <Button size="medium" style={{ minWidth: "150px" }} color="primary" variant="outlined" disableElevation disableRipple disabled={loader} onClick={handleCancel}>
                            
                            cancel
                        </Button>
                    </div>
                    }
                </div>
                <div className="webSearch">
                    <ul className="flexWrap alignCntr">
                        {selectedChips.map((each) => (
                            <>
                                <li className="pdngXS">
                                    <Chip
                                        key={each.userId}
                                        label={each.firstName}
                                        onDelete={() => handleDeleteChip(each)}
                                        value={each.firstName}
                                    />
                                </li>
                            </>
                        ))}
                    </ul>
                </div>
                <div className="flexCol pdngSM">
                    {reportData?.length > 0 ?
                        <TableData
                            reportData={reportData}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            handleChangePage={handleChangePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            getAppointmentDetail={getAppointmentDetail}
                            count={count}
                            user={user}
                            setSelectedUserId = {setSelectedUserId}
                        />
                        : !loader && reportData?.length === 0 &&
                        <div className="nodataBlock flexOne">
                            <div className="ndIconBox">
                                <img src="/images/icons/no-schedule-new.png" alt="icon" className="invertPrimary" />
                            </div>
                            <span className="nodataHdng">No Records Found</span>
                        </div>
                    }
                </div> 
            </>: 
            <>
                <div className="filterWidth pdngXS">
                    <Breadcrumbs aria-label="breadcrumb" style={{ display: 'flex', whiteSpace: 'nowrap', flexWrap: 'nowrap' }}>
                        <Link 
                            underline="hover" 
                            color="primary"  
                            onClick={handleBack} 
                            style={{ cursor: 'pointer' }}
                        >
                            {user}
                        </Link>
                        <Typography className="capitalTxt" color="textPrimary" noWrap>
                            {userName ? user === 'Doctor' ? `Dr ${userName}` : `${userName}`: 'Appointments'}
                        </Typography>
                    </Breadcrumbs>
                </div>
                <div className="flexWrap alignCntr">
                    <div className="datePickerWidth pdngXS">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                fullWidth
                                size="small"
                                className="pickerInput"
                                inputVariant="outlined"
                                value={appFrom}
                                onChange={(d) => {
                                    setAppFrom(d);
                                }}
                                animateYearScrolling
                                placeholdertext="from"
                                format="dd/MM/yyyy"
                                maxDate={new Date()}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div className="datePickerWidth pdngXS">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                fullWidth
                                size="small"
                                className="pickerInput"
                                inputVariant="outlined"
                                value={appTo}
                                onChange={(d) => {
                                    setAppTo(d); 
                                }}
                                animateYearScrolling
                                placeholdertext="to"
                                format="dd/MM/yyyy"
                                maxDate={new Date()}
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                </div>
                <div className="flexCol pdngSM">
                    {appointmentData?.length > 0 ?
                        <AppointmentTable
                            reportData={appointmentData}
                            getAppointmentDetail={getAppointmentDetail}
                            // page={appPage}
                            // rowsPerPage={appRowsPerPage}
                            // handleChangePage={handleChangeAppPage}
                            // handleChangeRowsPerPage={handleChangeAppRowsPerPage}
                            selectedUserId = {selectedUserId}
                            count={appCount}
                            user={user}
                        /> : !loader && appointmentData?.length === 0 &&
                        <div className="nodataBlock flexOne">
                            <div className="ndIconBox">
                                <img src="/images/icons/no-schedule-new.png" alt="icon" className="invertPrimary" />
                            </div>
                            <span className="nodataHdng">No Records Found</span>
                        </div> }
                </div>
            </> }
            {loader && <Loader />}
        </div>
    );
}
export default SearchDoctors;
